module.exports = __webpack_public_path__ + "static/media/view2.f29f715c.jpg";